<app-header [search]="true"></app-header>
<div class="search_div">
  <div class="search_header">
    <h1 class="search_header_title">{{ 'landing.form.title' | translatePipe }}</h1>
  </div>
  <div class="search_content" *ngIf="idNumber !== ''">
    <p class="text">{{ 'landing.form.id_number' | translatePipe  }}<span>{{ idNumber }}</span></p>
    <p class="text">{{ 'landing.form.submission_date' | translatePipe  }}<span>{{ submissionDate | date: 'dd/MM/yyyy' }}</span></p>
    <p class="text">{{ 'landing.form.submission_time' | translatePipe  }}<span>{{ submissionTime | date: 'h:mm:ss' }}</span></p>
    <p class="text">{{ 'landing.form.full_name' | translatePipe  }}<span>{{ fullName }}</span></p>
    <p class="text">{{ 'landing.form.employee_number' | translatePipe  }}<span>{{ employeeNumber }}</span></p>
    <p class="text">{{ 'landing.form.work_area' | translatePipe  }}<span>{{ workArea }}</span></p>
  </div>
</div>
